import React, { FC, useContext, useEffect, useMemo } from 'react';

import { Form, Formik } from 'formik';

import BasicModal from '../../../../../components/modals/basicModal';
import styled from 'styled-components';

//constants
import aampeTheme from '../../../../../constants/aampeTheme';
import { FormulaTestMessageType } from '../../../../../constants/formula';
import { FormulaType } from '../../../../../constants/formulaType';
import { ModalHeaderStyle } from '../../../../attributes/constants';

// contexts
import { EditorContext } from '../../../../../context/EditorContext';

import useMessageContentGetAndUpdate from 'hooks/message-content/useMessageContentGetAndUpdate';

// models
import { FormulaTestMessageFormValues } from 'models/formula.model';

//components
import TestFormulaFooter from './TestFormulaFooter';
import TestFormulaV1 from './TestFormulaV1';
import {
    initialFilters,
    TestFormulaSectionType,
    TestMessageStep,
} from './constant';

interface TestFormulaModalProps {
    handleClose: () => void;
    className?: string;
}
const TestFormulaModal: FC<TestFormulaModalProps> = ({
    handleClose,
    className,
}) => {
    const { editorDetails, setEditorDetails } = useContext(EditorContext);

    const { formula, formulaType } = editorDetails;

    useEffect(() => {
        setEditorDetails({
            ...editorDetails,
            showSmallPhone: true,
            selectRandomFilters: false,
            previewError: null,
            isPreviewError: false,
        });
    }, []);

    const { data: selectedMessageContent } = useMessageContentGetAndUpdate(
        formula?.id,
    );

    const handleOnClose = () => {
        setEditorDetails({
            ...editorDetails,
            showSmallPhone: false,
            selectRandomFilters: false,
            previewError: null,
            isPreviewError: false,
        });
        handleClose();
    };

    const headerStyle = {
        ...ModalHeaderStyle,
        padding: aampeTheme.spacing4(4),
        fontSize: aampeTheme.size.font.text,
        fontWeight: 400,
        backgroundColor: aampeTheme.colors.backgroundWG02,
        lineHeight: undefined,
    };

    const initialValues = useMemo<FormulaTestMessageFormValues>(() => {
        return {
            filters: initialFilters,
            contact_ids: [],
            notification_token: undefined,
            formulaType,
            users: [],
            current_state: FormulaTestMessageType.OneUser,
            currentSection: TestFormulaSectionType.FORM,
            testMessageContent: null,
            currentStep: TestMessageStep.PREVIEW,
            languageId: selectedMessageContent?.language_id,
            message_content_id: selectedMessageContent?.id ?? '',
            formula_id: selectedMessageContent?.formula_id ?? undefined,
            showDataset: false,
            isNextButtonDisabled: true,
            template_id:
                formulaType === FormulaType.email
                    ? formula?.additional_metadata?.email_template_id
                    : undefined,
            componentAttachedLabel: {},
        };
    }, [selectedMessageContent, formulaType, formula]);

    if (!selectedMessageContent || !formula) return null;

    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={() => {}}
                validateOnChange
                validateOnMount
                validateOnBlur
            >
                {({ values }) => {
                    return (
                        <Form>
                            <BasicModal
                                childContainerStyle={{
                                    overflow: 'auto',
                                    padding: 'undefined',
                                }}
                                containerBodyStyle={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                                width={'1200px'}
                                header="Send a test message"
                                handleClose={handleOnClose}
                                headerStyle={headerStyle}
                                className={className}
                                footer={
                                    <TestFormulaFooter
                                        handleClose={handleOnClose}
                                    />
                                }
                                footerStyle={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    borderTop: `1px solid ${aampeTheme.colors.interactiveWG01}`,
                                    position: 'sticky',
                                }}
                            >
                                <StyledTestFormulaV1
                                    deeplink={formula?.deeplink as string}
                                    handleClose={handleOnClose}
                                    isModalView
                                    formulaType={formulaType || undefined}
                                    className={className}
                                    currentTab={values.currentStep}
                                />
                            </BasicModal>
                        </Form>
                    );
                }}
            </Formik>
        </>
    );
};

const StyledTestFormulaV1 = styled(TestFormulaV1)({
    margin: aampeTheme.spacing(0),
    height: 'auto',
    minHeight: '650px',
    border: 'none',
    '& > div': {
        height: 'auto',
        margin: aampeTheme.spacing(0),
        padding: aampeTheme.spacing(0),
        '& > span': {
            display: 'none',
        },
        '& > p': {
            margin: aampeTheme.spacing(0),
            textAlign: 'start',
            color: aampeTheme.colors.neutral09,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
        },
    },
});

export default TestFormulaModal;
